import { Component, OnInit } from '@angular/core';
import { ScriptsModule } from '../../modules/scripts.module';
import { ActivatedRoute, Router } from '@angular/router';
import { IntermService } from '../../services/general/interm.service';
declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-intermediarios',
  templateUrl: './intermediarios.component.html',
  styleUrls: ['./intermediarios.component.css'],
  providers: [IntermService]
})
export class IntermediariosComponent implements OnInit {

 public modelLogin;
 public tituloInterm;
 public mensajeInterm;
 public rutaInterm;
 public section;    
    
  constructor(private route: ActivatedRoute,private router: Router,private int:IntermService) { }

  ngOnInit() {
    let scripts = new ScriptsModule;
    scripts.loadScript('assets/js/scripts/intermediarios.js');
      
       var usuario=  localStorage.getItem('currentUsuario');  
      
       if(usuario!=null)          
          this.router.navigate(['/intermediarios/plataforma']);  
      else
        {
            this.modelLogin={user:"",pass:""};
        }          
  }        
   onSubmit(){  
    //GENERAMOS CODIGO REFERENCIA EN CADA CLICK
     $('#divCargador').show();
    var user= JSON.stringify(this.modelLogin);  
    this.int.validateUser(user) .then(resc => {        
        this.tituloInterm="";
        this.rutaInterm="/intermediarios";
        if(resc.estado==1){
            $('#divCargador').hide();
            localStorage.setItem('currentUsuario',  JSON.stringify(resc) );
            this.router.navigate(['/intermediarios/plataforma']);      
        } 
        else if(resc.estado==0){           
             
            this.mensajeInterm="Usuario deshabilitado"; 
            $('#divCargador').hide();
            $('#modalNotif').modal('show');
  
        }
         else if(resc.estado==2){
            
             this.mensajeInterm="Debe validar usuario y/o contraseña";
             $('#divCargador').hide();
             $('#modalNotif').modal('show');
        }
         else if(resc.estado==4){
            
             this.mensajeInterm="Problemas obteniendo informacion del usuario";
             $('#divCargador').hide();
             $('#modalNotif').modal('show');
        }
        
    });     
  }    
    showSection(n){
        this.section=n;
        $('#modalIntermediarios').modal('show'); 
    }

    onRSubmit(){
         
     $('#divCargador').show();        
        var user= JSON.stringify(this.modelLogin);  
        this.int.recoverUser(user) .then(resc => {        
          
            if(resc.estado==1 || resc.estado==0){
                $('#modalReContrasenia').modal('hide'); 
                 this.mensajeInterm="Correo enviado"; 
                $('#divCargador').hide();
                $('#modalNotif').modal('show');   
            }            
             else if(resc.estado==2){
                 $('#modalReContrasenia').modal('hide'); 
                 this.mensajeInterm="Usuario y/o email invalido";
                 $('#divCargador').hide();
                 $('#modalNotif').modal('show');
            }
             else if(resc.estado==4){
                 
                 $('#modalReContrasenia').modal('hide'); 
                 this.mensajeInterm="Problemas obteniendo informacion del usuario";
                 $('#divCargador').hide();
                 $('#modalNotif').modal('show');
            }
        });
    }   
    
    showPopup(){
        
        $('#modalReContrasenia').modal('show'); 
    }
    
  
  

}



// WEBPACK FOOTER //
// ./src/app/components/intermediarios/intermediarios.component.ts